import {z} from "zod/v4-mini"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {box2Like, remotelyColorLike, vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const BrushSettings = z.object({
    color: remotelyColorLike,
    width: z.number().check(z.gte(0)),
    hardness: z._default(z.number().check(z.gte(0), z.lte(1)), 0.8),
})

export type BrushSettings = z.infer<typeof BrushSettings>

export const BrushStroke = z.object({
    settings: BrushSettings,
    path: z.array(vector2Like),
})

export type BrushStroke = z.infer<typeof BrushStroke>

export const definition = {
    validation: {
        returns: z.object({
            resultImage: anyImageOpResult,
            boundingBox: box2Like,
        }),
        parameters: z.object({
            sourceImage: anyImageOpResult,
            brushStrokes: z.array(BrushStroke),
            options: z.prefault(
                z.object({
                    tilingEnabled: z._default(z.boolean(), true),
                }),
                {},
            ),
        }),
    },
}
